import axios from "axios";
import Qs from "qs";
import {uuidv4} from "./Util";
import {ApiError} from "./ApiError";
import store from "../store";

export const getHost = () => {
    let localEnv = localStorage.getItem("env");
    if (localEnv) localEnv = JSON.parse(localEnv);
    const vars = localEnv || store.getState().Variables.env;
    const prodHosts = [
        "wm.bitgo.com",
        "tkm.bitgo.com"
    ];
    if (prodHosts.includes(window.location.host) && vars?.API_ENV === "production") {
        // only allow production env overriding if the host is production, e.g. AST
        return vars?.API_HOST;
    }
    return process.env.REACT_APP_API_HOST;
};

const requestManager = {
    isRefreshing: false,
    pendingRequests: [],
    maxRetryAttempts: 3,
};

const sendRequest = (user, method, path, data, params) => {
    return axios({
        method,
        url: path.startsWith(getHost()) ? path : getHost() + path,
        data,
        params,
        headers: {
            Authorization: `Bearer ${user.token}`,
        },
        paramsSerializer: params =>
            Qs.stringify(params, { arrayFormat: "repeat" }),
    });
};

const processPendingRequests = (newUser) => {
    requestManager.pendingRequests.forEach(({ method, path, data, params, resolve, reject }) => {
        sendRequest(newUser, method, path, data, params)
            .then(resolve)
            .catch(reject);
    });
    requestManager.pendingRequests = [];
};

export async function apiRequest(method, path, data, params) {
    let user = JSON.parse(localStorage.getItem("authUser"));
    if (!user) return Promise.reject(new ApiError({ status: 403 }));

    try {
        return await sendRequest(user, method, path, data, params);
    } catch (error) {
        const originalRequest = { method, path, data, params };

        if (error.response?.status === 401) {
            if (requestManager.isRefreshing) {
                // Queue this request to be tried again after token refresh
                return new Promise((resolve, reject) => {
                    requestManager.pendingRequests.push({ ...originalRequest, resolve, reject, retryCount: 0 });
                });
            }

            requestManager.isRefreshing = true;

            try {
                const refreshResponse = await axios.post(getHost() + "/refreshToken", {
                    refreshToken: user.refreshToken,
                    deviceId: getDeviceId(),
                    timeout: getTimeout(),
                });

                user = refreshResponse.data;
                localStorage.setItem("authUser", JSON.stringify(user));

                // Retry the original request with the new token
                const retryResponse = await sendRequest(user, method, path, data, params);

                // Resolve any queued requests with the new token
                processPendingRequests(user);

                return retryResponse;
            } catch (refreshError) {
                localStorage.removeItem("authUser");
                window.location = "/login?error=timeout";
                return Promise.reject(new ApiError(refreshError));
            } finally {
                requestManager.isRefreshing = false;
            }
        }

        return Promise.reject(new ApiError(error));
    }
};

export function getDeviceId() {
    let deviceId = localStorage.getItem("HeightZeroDevice");
    if (!deviceId) {
        deviceId = uuidv4();
        localStorage.setItem("HeightZeroDevice", deviceId);
    }
    return deviceId;
}

export function getTimeout(timeout) {
    if (timeout) {
        localStorage.setItem("HeightZeroTimeout", timeout);
    } else {
        timeout = localStorage.getItem("HeightZeroTimeout") || "30";
    }
    return timeout;
}
